export default __webpack_public_path__ + "static/media/product-overview-bg.7282c10d.webp";